import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import MarketingHeader from 'src/components/layout/MarketingHeader';
import SiteFooter from 'src/components/layout/SiteFooter';
import { getBlogNeighbors, getBlogPost } from 'src/content/blogPosts';
import { markdownToHtml } from 'src/helpers/blogMarkdown';
import { buildBlogPostMeta, formatBlogDate } from 'src/helpers/blogMeta';

function BlogPostPage() {
  const { slug } = useParams();
  const post = getBlogPost(slug);
  const neighbors = post ? getBlogNeighbors(post.slug) : { prev: null, next: null };
  const meta = post ? buildBlogPostMeta(post) : null;

  useEffect(() => {
    document.title = meta ? meta.title : 'Post não encontrado · Blog ÁgilOdonto';
  }, [meta]);

  if (!post) {
    return (
      <div className="min-h-screen bg-[#faf8fc] font-inter text-[#4b5563]">
        <MarketingHeader active="blog" anchorPrefix="/" />
        <main className="px-5 py-24 text-center">
          <h1 className="font-sora text-3xl font-extrabold text-[#0f172a]">Post não encontrado</h1>
          <Link to="/blog" className="mt-4 inline-block text-sm font-semibold text-[#7c3aed]">
            Voltar ao blog
          </Link>
        </main>
        <SiteFooter />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#faf8fc] font-inter text-[#4b5563]">
      <MarketingHeader active="blog" anchorPrefix="/" />

      <main className="px-5 py-10 sm:px-10 sm:py-14 lg:px-20">
        <article className="mx-auto max-w-[760px]">
          <Link to="/blog" className="text-sm font-semibold text-[#7c3aed]">
            ← Todos os posts
          </Link>
          <img
            src={post.cover}
            alt={post.title}
            width={1200}
            height={630}
            className="mt-5 aspect-[1200/630] w-full rounded-[20px] border border-[#ede9fe] object-cover"
          />
          <header className="mt-6">
            <p className="font-sora text-sm font-bold uppercase text-[#7c3aed]">{post.seriesLabel}</p>
            <h1 className="mt-2 font-sora text-3xl font-extrabold leading-tight text-[#0f172a] sm:text-4xl">
              {post.title}
            </h1>
            <time className="mt-3 block text-xs text-[#9ca3af]" dateTime={post.date}>
              {formatBlogDate(post.date)}
            </time>
          </header>
          <div
            className="blog-prose mt-8 text-[17px] leading-[1.75] text-[#334155] [&_a]:font-semibold [&_a]:text-[#7c3aed] [&_a]:underline [&_h2]:mb-3 [&_h2]:mt-9 [&_h2]:font-sora [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-[#0f172a] [&_li]:my-1.5 [&_ol]:mb-4 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:mb-4 [&_strong]:text-[#0f172a] [&_ul]:mb-4 [&_ul]:list-disc [&_ul]:pl-5"
            dangerouslySetInnerHTML={{ __html: markdownToHtml(post.body) }}
          />
          <nav className="mt-10 grid gap-3 border-t border-[#ede9fe] pt-6 sm:grid-cols-2" aria-label="Série Especialidades">
            {neighbors.prev ? (
              <Link
                to={`/blog/${neighbors.prev.slug}`}
                className="rounded-2xl border border-[#ede9fe] bg-white p-4 text-[#0f172a] hover:border-[#ddd6fe] hover:text-[#7c3aed]"
              >
                <span className="mb-1 block text-xs font-bold uppercase tracking-wide text-[#7c3aed]">Anterior</span>
                {neighbors.prev.title}
              </Link>
            ) : <span />}
            {neighbors.next ? (
              <Link
                to={`/blog/${neighbors.next.slug}`}
                className="rounded-2xl border border-[#ede9fe] bg-white p-4 text-[#0f172a] hover:border-[#ddd6fe] hover:text-[#7c3aed]"
              >
                <span className="mb-1 block text-xs font-bold uppercase tracking-wide text-[#7c3aed]">Próximo</span>
                {neighbors.next.title}
              </Link>
            ) : <span />}
          </nav>
        </article>
      </main>

      <SiteFooter />
    </div>
  );
}

export default BlogPostPage;
